<template>
    <div id="pallets">
        <b-container class="centerv">
            <b-row class="centerv">
                <b-col lg="6">
                    <div class="wrapper text-center mb-3">
                        <img class="logo" src="../assets/img_logo.svg" alt="">
                    </div>
                    <div class="wrapper text-center mb-3">
                        <img class="img-fluid" src="../assets/img_captacion.png" alt="">
                    </div>
                </b-col>
                <b-col lg="6">
                    <div class="wrapper mb-3">
                        <h1>Have a project in mind?</h1>
                        <p>We design and manufacture customized wooden packaging. <i>Send us a message for more information.</i></p>
                        <p style="color: #Bf0000;" v-if="messageSend">{{ messageSend }}</p>
                        <div class="mb-3 form-floating">
                            <b-form-input id="input-1" v-model="name" placeholder="Name*" type="text"></b-form-input>
                            <label for="input-1">Name*</label>
                        </div>
                        <div class="mb-3 form-floating">
                            <b-form-input id="input-2" v-model="email" placeholder="Email*" type="text"></b-form-input>
                            <label for="input-2">E-mail*</label>
                        </div>
                        <div class="mb-3 form-floating">
                            <b-form-input id="input-3" v-model="phone" placeholder="Phone*" type="text"></b-form-input>
                            <label for="input-3">Phone number*</label>
                        </div>
                        <div class="mb-3"> 
                            <label for="input-3">Write your message here</label>
                            <b-form-textarea id="input-3" v-model="message" rows="2" max-rows="3"></b-form-textarea>
                        </div>
                        <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                        <b-button class="btn btn-modal" v-on:click="sendMessage">SEND</b-button>
                    </div>
                </b-col>
                <b-col md="12" class="privacy-wrapper">
                    <router-link class="privacy-link" :to="{ name: 'Privacy'}">{{ $t('contact.privacy') }}</router-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'

    export default {
        components: {
        },
        created() {
            this.$i18n.locale = 'en-US';
            localStorage.setItem("lang", this.$i18n.locale)
        },
        data() {
            return {
                name: '',
                email: '',
                phone: '',
                message: '',
                pet:'',
                messageSend: ''
            }
        },
        methods: {
            sendMessage: async function(){
                var responseData
                if(this.name != '' && this.email != '' && this.pet == ''){
                    await axios.post('https://quattromg.com/lumberworks/phpmailerpalletsEN.php', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    })
                    .then((response) => {
                        responseData = response.data
                    })
                    .catch((error) => {
                        /* eslint-disable no-console */
                        console.log(error);
                        /* eslint-enable no-console */
                    });
                    console.log(responseData);
                    if(responseData==200 || responseData=='200') {
                        this.$router.push({ name: 'ThanksEN'})
                    } else {
                        this.messageSend = 'Error sending message, try again later.'
                    }
                } else {
                    this.messageSend = 'Enter the necessary information in the fields.'
                }
            }
        }
    }
</script>

<style scoped>
#pallets{
    background: #F1EBE3;
    min-height: 100vh;
    display: flex;
    padding-top: 50px;
    padding-bottom: 50px;
}
.wrapper{
    border: 1px solid #503B2D;
    padding: 5% 10%;
    border-radius: 20px;
}
.logo{
    width: 100%;
    max-width: 270px;
}
h1{
    font-size: 32px;
    font-weight: 500;
}
p{
    font-size: 18px;
    font-weight: 300;
}
i{
    font-weight: 400;
}
.btn{
    background: transparent;
    color: #503B2D;
    border: 1px solid #503B2D;
    text-transform: uppercase;
    border-radius: 20px;
    width: 220px;
}
.btn:hover,
.btn:focus,
.btn:active{
    background: transparent !important;
    color: #503B2D !important;
    border: 1px solid #503B2D !important;
}

.form-floating > .form-control{
    background: transparent;
    border: none;
    border-bottom: #503B2D solid 1px;
    border-radius: 0;
    color: #503B2D;
    font-size: 20px;
    padding-left: 0;
    outline: none !important;
}
/* .form-floating > .form-control, .form-floating > .form-control-plaintext, .form-floating > .form-select {
    height: calc(4rem + 2px);
} */

.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    -webkit-transform: scale(0.85) translateY(-1rem) translateX(0rem);
    transform: scale(0.85) translateY(-1rem) translateX(0rem);
}

label{
    color: #503B2D;
    font-size: 20px;
}
textarea{
    background: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #503B2D;
    outline: none;
    font-size: 20px;
    color: #503B2D;
}
input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 20px;
    color: #503B2D !important;
    padding-left: 0;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #503B2D !important;
    padding-left: 0 !important;
}

.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}

.privacy-wrapper{
    text-align: center;
    padding-top: 30px;
}
.privacy-wrapper a{
    color: #503B2D4D;
    text-decoration: none;
    font-weight: 300;
    font-size: 20px !important;
}

/* @media (max-width: 768px){
    h1{
        font-size: 50px;
    }
    p{
        font-size: 20px;
    }
    .btn{
        font-size: 12px;
    }
} */
</style>